import { oz } from '@weft/utils';

export const CreditProductConfigurationSchema = oz.object({
  shouldCreateSeparateInvoice: oz.boolean().default(false),
}).openapi('CreditProductConfiguration');

export type CreditProductConfiguration = oz.infer<typeof CreditProductConfigurationSchema>;